export const REQUEST_FEEDBACK_QUESTIONS = 'app/Feedback/REQUEST_FEEDBACK_QUESTIONS';
export const REQUEST_FEEDBACK_QUESTIONS_SUCCESS = 'app/Feedback/REQUEST_FEEDBACK_QUESTIONS_SUCCESS';
export const REQUEST_FEEDBACK_QUESTIONS_FAILURE = 'app/Feedback/REQUEST_FEEDBACK_QUESTIONS_FAILURE';
export const SUBMIT_FEEDBACK_ANSWERS = 'app/Feedback/SUBMIT_FEEDBACK_ANSWERS';
export const FEEDBACK_SUBMISSION_FAILURE = 'app/Feedback/FEEDBACK_SUBMISSION_FAILURE';
export const FEEDBACK_SUBMISSION_SUCCESS = 'app/Feedback/FEEDBACK_SUBMISSION_SUCCESS';
